export default function Terms(){
    return (
        <div className="App">
            <header className="App-header">
                <p>Here will be the Terms of Service</p>
            </header>
        </div>
    )
}